import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-file-cog',
  templateUrl: './icon-file-cog.component.html',
  styleUrl: './icon-file-cog.component.scss',
  standalone: false,
})
export class IconFileCogComponent {
  @Input() tooltip?: string;
}
